import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { t } from '../../../../modules/infra/i18n';
export var WaitingListLabel = function (_a) {
    var customersWaiting = _a.customersWaiting;
    return (_jsxs("span", { children: [t('appointment:waiting_list.waiting_list'), !!customersWaiting && _jsx("span", { className: "c-waiting-customers", children: customersWaiting })] }));
};
